<div class="modal-head">
  @if (isCloseButtonEnabled && (isTutorialActive$ | async) == false) {
    <button class="close-btn" (click)="closeButtonClick()">
      <img src="/assets/img/header/back-btn.svg" alt="" />
    </button>
  }
  @if (isPending) {
    Loading
  } @else {
    Create AI Girl
  }
</div>

<div class="pending-block" [class.hidden]="!isPending">
  <ng-lottie
    class="lottie-animation"
    [options]="pendingAnimationOptions"
    (animationCreated)="onLottieAnimationCreated()"
  ></ng-lottie>

  <div *ngIf="!isPendingAnimationCreated" class="animation-preloader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>

  <h2>We create your Girlfriend</h2>

  <div
    class="light-shadow"
    style="width: 13.38rem; height: 22.75rem; transform: translateY(4rem)"
  ></div>
  <div
    class="light-shadow"
    style="width: 32.62rem; height: 4.31rem; transform: translateY(18rem)"
  ></div>
  <div class="dark-shadow"></div>
</div>
@if (!isPending) {
  <div class="navigation-marker">
    @for (n of [0, 1, 2, 3, 4, 5, 6, 7, 8]; track n) {
      <div [class.active]="activeSlideIndex >= n"></div>
    }
  </div>

  <swiper #swiper [config]="swiperConfig" class="swiper">
    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Choose Style</h2>
        <div class="items-container">
          @for (style of styles; track $index) {
            <div
              (click)="selectedStyle = style; updateNextButtonState()"
              class="config-item"
            >
              <div class="config-item-inner style-item">
                <img [src]="style.img1" alt="" />
                <span> {{ style.text }} </span>
              </div>

              @if (selectedStyle === style) {
                <div class="config-item-border border-wide"></div>
              }
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Ethnicity</h2>
        <div class="items-container">
          @for (ethnicity of ethnicities; track $index) {
            <div
              (click)="selectedEthnicity = ethnicity; updateNextButtonState()"
              class="config-item"
            >
              <div class="config-item-inner ethnicity-item">
                @if (selectedStyle?.value === "Realistic") {
                  <img [src]="ethnicity.img1" alt="" />
                } @else {
                  <img [src]="ethnicity.img2" alt="" />
                }
                <span>
                  {{ ethnicity.text }}
                </span>
              </div>

              @if (selectedEthnicity === ethnicity) {
                <div class="config-item-border border-wide"></div>
              }
            </div>
          }
        </div>
        <div class="age-slider">
          <label class="slider-title">Age</label>
          <input
            [(ngModel)]="selectedAge"
            type="range"
            [min]="MinAge"
            [max]="MaxAge"
            class="slider"
            [style.--value.%]="
              ((selectedAge - MinAge) / (MaxAge - MinAge)) * 100
            "
          />
          <div class="slider-labels">
            <span>18</span>
            <span class="current">{{ selectedAge }}</span>
            <span>55</span>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Eyes Color</h2>
        <div class="items-container gap-small">
          @for (color of eyeColors; track $index) {
            <div
              (click)="selectedEyeColor = color; updateNextButtonState()"
              class="config-item"
            >
              <div class="config-item-inner eye-item">
                @if (selectedStyle?.value === "Realistic") {
                  <img [src]="color.img1" alt="" />
                } @else {
                  <img [src]="color.img2" alt="" />
                }
                <span>
                  {{ color.text }}
                </span>
              </div>

              @if (selectedEyeColor === color) {
                <div class="config-item-border border-wide"></div>
              }
            </div>
          }
        </div>
        <h2>Hair Style</h2>
        <div class="items-container gap-small">
          @for (style of hairStyles; track $index) {
            <div
              (click)="selectedHairStyle = style; updateNextButtonState()"
              class="config-item"
            >
              <div class="config-item-inner hairstyle-item">
                @if (selectedStyle?.value === "Realistic") {
                  <img [src]="style.img1" alt="" />
                } @else {
                  <img [src]="style.img2" alt="" />
                }
                <span>
                  {{ style.text }}
                </span>
              </div>

              @if (selectedHairStyle === style) {
                <div class="config-item-border border-wide"></div>
              }
            </div>
          }
        </div>
        <h2>Hair Color</h2>
        <div class="items-container gap-small row-gap-small">
          @for (color of hairColors; track $index) {
            <div
              (click)="selectedHairColor = color; updateNextButtonState()"
              class="config-item"
            >
              @if (selectedHairColor === color) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner haircolor-item">
                <div class="color-block" [style.background]="color.img1"></div>
                {{ color.text }}
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Body Type</h2>
        <div class="items-container gap-small">
          @for (bodyType of bodyTypes; track $index) {
            <div
              (click)="selectedBodyType = bodyType; updateNextButtonState()"
              class="config-item"
            >
              <div class="config-item-inner body-item">
                @if (selectedStyle?.value === "Realistic") {
                  <img [src]="bodyType.img1" alt="" />
                } @else {
                  <img [src]="bodyType.img2" alt="" />
                }
                <span>
                  {{ bodyType.text }}
                </span>
              </div>

              @if (selectedBodyType === bodyType) {
                <div class="config-item-border border-wide"></div>
              }
            </div>
          }
        </div>
        <h2>Breast Size</h2>
        <div class="items-container gap-small">
          @for (size of breastSizes; track $index) {
            <div
              (click)="selectedBreastSize = size; updateNextButtonState()"
              class="config-item"
            >
              @if (selectedBreastSize === size) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner">
                {{ size.text }}
              </div>
            </div>
          }
        </div>
        <h2>Butt Size</h2>
        <div class="items-container gap-small">
          @for (size of buttSizes; track $index) {
            <div
              (click)="selectedButtSize = size; updateNextButtonState()"
              class="config-item"
            >
              @if (selectedButtSize === size) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner">
                {{ size.text }}
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Personality</h2>
        <div class="items-container">
          @for (personality of personalities; track $index) {
            <div
              (click)="
                selectedPersonality = personality; updateNextButtonState()
              "
              class="config-item"
            >
              @if (selectedPersonality === personality) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner personality-item">
                <div class="label">
                  {{ personality.text }}
                </div>
                <div
                  class="description"
                  [innerHTML]="personality.description"
                ></div>
                <img [src]="personality.img1" alt="" />
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Occupation</h2>
        <div class="items-container">
          @for (occupation of occupations; track $index) {
            <div
              (click)="selectedOccupation = occupation; updateNextButtonState()"
              class="config-item"
            >
              @if (selectedOccupation === occupation) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner emoji-item">
                {{ occupation.text }}
                <img [src]="occupation.img1" alt="" />
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Hobbies</h2>
        <p class="hobbies-description">Multi choice (3 max)</p>
        <div class="items-container">
          @for (hobby of hobbies; track $index) {
            <div
              (click)="selectHobby(hobby); updateNextButtonState()"
              class="config-item"
            >
              @if (selectedHobbies.includes(hobby)) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner emoji-item">
                {{ hobby.text }}
                <img [src]="hobby.img1" alt="" />
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <h2>Relationships with user</h2>
        <div class="items-container">
          @for (relationship of relationships; track $index) {
            <div
              (click)="
                selectedRelationship = relationship; updateNextButtonState()
              "
              class="config-item"
            >
              @if (selectedRelationship === relationship) {
                <div class="config-item-border"></div>
              }

              <div class="config-item-inner emoji-item">
                {{ relationship.text }}
                <img [src]="relationship.img1" alt="" />
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="slide-content">
        <img
          src="/assets/img/girl-creation/modal-bg.png"
          alt=""
          class="result-bg-image"
        />

        <h2>Summary</h2>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Style:</div>
            <div class="result-item">{{ selectedStyle?.value }}</div>
          </div>
          <div class="result-block">
            <div class="result-label">Age:</div>
            <div class="result-item">{{ selectedAge }}</div>
          </div>
          <div class="result-block">
            <div class="result-label">Ethnicity:</div>
            <div class="result-item">{{ selectedEthnicity?.value }}</div>
          </div>
          <div class="result-block">
            <div class="result-label">Eyes Color:</div>
            <div class="result-item">{{ selectedEyeColor?.value }}</div>
          </div>
        </div>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Hair Style:</div>
            <div class="result-item">{{ selectedHairStyle?.value }}</div>
          </div>
          <div class="result-block">
            <div class="result-label">Hair Color:</div>
            <div class="result-item">{{ selectedHairColor?.value }}</div>
          </div>
        </div>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Body Type:</div>
            <div class="result-item">{{ selectedBodyType?.value }}</div>
          </div>
          <div class="result-block">
            <div class="result-label">Breast Size:</div>
            <div class="result-item">{{ selectedBreastSize?.value }}</div>
          </div>
          <div class="result-block">
            <div class="result-label">Butt Size:</div>
            <div class="result-item">{{ selectedButtSize?.value }}</div>
          </div>
        </div>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Personality:</div>
            <div class="result-item fit">
              {{ selectedPersonality?.value }}
              <img [src]="selectedPersonality?.img1" alt="" />
            </div>
          </div>
        </div>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Occupation:</div>
            <div class="result-item fit">
              {{ selectedOccupation?.value }}
              <img [src]="selectedOccupation?.img1" alt="" />
            </div>
          </div>
        </div>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Hobbies:</div>
            <div class="result-hobbies">
              @for (hobby of selectedHobbies; track $index; let last = $last) {
                <div class="result-item">
                  {{ hobby?.value }}
                  <img [src]="hobby?.img1" alt="" />
                </div>
              }
            </div>
          </div>
        </div>

        <div class="result-row">
          <div class="result-block">
            <div class="result-label">Relationships with user:</div>
            <div class="result-item fit">
              {{ selectedRelationship?.value }}
              <img [src]="selectedRelationship?.img1" alt="" />
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </swiper>

  <div class="buttons-wrapper">
    <app-button
      (click)="prevSlide()"
      [disabled]="activeSlideIndex === 0"
      [variant]="'gray'"
      class="prev-button"
    >
      Back
    </app-button>
    <app-button
      (click)="nextSlide()"
      [disabled]="!isNextButtonEnabled"
      class="next-button"
    >
      @if (activeSlideIndex < 8) {
        Next
      } @else {
        Create
      }
    </app-button>
  </div>
}
